export enum ValueHistoryDataTabs {
  Positive,
  Negative,
}

export enum DashboardWidgetName {
  AccountsByType = 'AccountsByType',
  CashFlowProjections = 'CashFlowProjections',
  Commitments = 'Commitments',
  IncomeChangeSnapshot = 'IncomeChangeSnapshot',
  IncomeHistoryBarsChart = 'IncomeHistoryBarsChart',
  IncomeHistoryTable = 'IncomeHistoryTable',
  IncomePivot = 'IncomePivot',
  IrrMoic = 'IrrMoic',
  LinkedTransactions = 'LinkedTransactions',
  LinkedTransactionsPivot = 'LinkedTransactionsPivot',
  PerformancePivot = 'PerformancePivot',
  SectionDelimiter = 'SectionDelimiter',
  ValueChangeSnapshot = 'ValueChangeSnapshot',
  ValueHistoryBarsChart = 'ValueHistoryBarsChart',
  ValueHistoryPieChart = 'ValueHistoryPieChart',
  ValueHistoryTable = 'ValueHistoryTable',
  ValuePivot = 'ValuePivot',
}
